import { FC } from 'react';
import classnames from 'classnames';

import Button from '@components/atoms/button';
import type { SanityCtaBlock } from '@lib/sanity/types';

type CtaBlockProps = SanityCtaBlock;

const CtaBlock: FC<CtaBlockProps> = ({
  heading,
  bodyText,
  buttonText,
  buttonUrl,
  variant
}) => (
  <section
    className={classnames(
      'px-4 py-16 text-center',
      variant === 'primary' ? 'bg-blue-600 text-white' : 'bg-gray-50'
    )}
  >
    <div className="mx-auto max-w-2xl">
      <h2
        className={classnames(
          'mb-4 text-3xl font-bold',
          variant === 'primary' ? 'text-white' : 'text-neutral-800'
        )}
      >
        {heading}
      </h2>
      {bodyText && (
        <p
          className={classnames(
            'mb-8 text-lg',
            variant === 'primary' ? 'text-blue-100' : 'text-gray-600'
          )}
        >
          {bodyText}
        </p>
      )}
      <Button
        href={buttonUrl}
        isLink
        variant={variant === 'primary' ? 'secondary' : 'primary'}
      >
        {buttonText}
      </Button>
    </div>
  </section>
);

export default CtaBlock;
